import { createReducer } from '@reduxjs/toolkit'

import { receivedReservation } from '../../actions/actions'
import { mapReservationResponseToBooking } from './bookingHelpers'

const initialState = null

const transaction = createReducer(initialState, {
  [receivedReservation]: (_, { payload: reservationResponse }) => {
    if (!reservationResponse.firstTime) return initialState

    const { resId, totalPrice, paymentMethod } = reservationResponse
    const booking = mapReservationResponseToBooking(reservationResponse)

    return {
      id: resId,
      totalMoney: totalPrice,
      totalPoints: 0,
      type: 'purchase',
      method: paymentMethod.toLowerCase(),
      coupons: [],
      booking
    }
  }
})

export default transaction
